<template>
    <div class="wapper">

        <el-page-header @back="goBack" content="发票信息详情" class="header">
        </el-page-header>
        <div class="content-wapper">
            <span class="title">发票基础信息</span>
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>发票信息编号</label>
                        <span>{{ info.invoiceInfoCode }}</span>
                    </div>
                    <div>
                        <label>开票申请编号</label>
                        <span>{{ info.invoiceApplyCode }}</span>
                    </div>
                    <div v-if="info.state != 1">
                        <label>发票号码</label>
                        <span>{{ info.invoiceCode }}</span>
                        <el-button type="text" size="mini" @click="updateRecord()">查看修改记录</el-button>
                    </div>
                </li>
                <li>
                    <div>
                        <label>发票状态</label>
                        <span>{{ info.stateName }}</span>
                    </div>
                    <div>
                        <label>发票抬头</label>
                        <span>{{ info.customerInvoiceName }}</span>
                    </div>
                    <div>
                        <label>合约开票公司</label>
                        <span>{{ info.companyName }}</span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>发票类型</label>
                        <span>{{ info.invoiceTypeName }}</span>
                    </div>
                    <div>
                        <label>发票总额</label>
                        <span>{{ info.totalInvoice }}</span>
                    </div>
                    <div>
                        <label>申请人</label>
                        <span>{{ info.ownerUserName }}</span>
                    </div>
                </li>
                <li>
                    <div v-if="info.state != 1">
                        <label>开票人</label>
                        <span>{{ info.drawerName }}</span>
                    </div>
                    <div v-if="info.state != 1">
                        <label>开票时间</label>
                        <span>{{ info.drawerTime }}</span>
                    </div>
                    <div>
                        <label>申请时间</label>
                        <span>{{ info.gmtCreate }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-wapper">
            <span class="title">发票内容信息</span>
            <ul class="info-wapper">
                <li>
                    <div>
                        <label>发票内容明细附件</label>
                        <span v-if="info.fileUrl">{{ info.fileName }}<el-button type="text"
                                @click="down(info.fileUrl)">下载附件</el-button></span>
                    </div>
                </li>
                <li>
                    <div>
                        <label>发票备注信息</label>
                        <span>{{ info.remark }}</span>
                    </div>
                </li>
            </ul>

            <el-table :data="info.contentList">
                <el-table-column prop="id" label="序号">
                </el-table-column>
                <el-table-column prop="invoiceContent" label="发票内容" width="420">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.invoiceContent" placement="top"><p>{{ scope.row.invoiceContent }}</p></el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="standard" label="规格型号">
                </el-table-column>
                <el-table-column prop="unit" label="单位">
                </el-table-column>
                <el-table-column prop="count" label="数量">
                </el-table-column>
                <el-table-column prop="price" label="单价">
                </el-table-column>
                <el-table-column prop="invoiceAmount" label="开票金额">
                </el-table-column>

            </el-table>

        </div>
        <div class="content-wapper" v-if="info.state == 3 || info.state == 4">
            <span class="title">发票作废信息明细</span>

            <el-table :data="info.invalidInfoList">
                <el-table-column prop="invalidUserName" label="作废申请人">
                </el-table-column>
                <el-table-column prop="gmtCreate" label="作废申请时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span style="color:blue;cursor:pointer;" @click="detailCheck(scope.row)">查看审核信息</span>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <el-dialog title="作废审核信息" :visible.sync="dialogCheckVisible">
            <div class="content-wapper" style="width:100%;" v-if="info.state != 1">
                <span class="title">订单审核信息</span>
                <examine ref="examine" :businessCode="ids" :templateId="templateId"></examine>
            </div>
        </el-dialog>

        <el-dialog title="修改记录" :visible.sync="dialogRecordVisible" width="30%">
            <el-table :data="info.oldInvoiceCodeList">
                <el-table-column label="修改记录序号">
                    <template slot-scope="scope">
                        <span> {{ (scope.$index + 1).toString().padStart(2, '0') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="invoiceCode" label="发票号码">
                </el-table-column>
                <el-table-column prop="drawerName" label="开票人">
                </el-table-column>
                <el-table-column width="200" prop="gmtModified" label="开票时间">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>

import _request from '@/utils/request.js'
import _tax from '@/service/tax-service'
import examine from '@/views/common/examine'
export default {
    components: {
        examine
    },
    data() {
        return {

                templateId: null,
                ids: null,
                dialogCheckVisible: false,
                dialogRecordVisible: false,
                info: {
                    invoiceApplyCode: null,
                    invoiceTitleInfo: {}
                },
                tableData: [],
                query: {
                    id:  this.$route.query.id
                },
                uploadType: null

        }
    },
    methods:{
         //详情数据
        getDetail() {
        _tax.getInfoDetail(
          this.query,
          response => {
            // 请求成功
            this.info = response
            //data.uploadType = response.uploadType

          }, response => {
            this.$notify({
              message: response,
              type: 'warning'
            })
          })
      },

       detailCheck(row){
        this.templateId = row.templateId
        this.ids = row.id
        this.dialogCheckVisible = true
      },

       updateRecord(){
        this.dialogRecordVisible = true
      },

       down(fileUrl){
        location.href = fileUrl
        },
        goBack () {
         this.$router.back()
      }
    },
    mounted() {
        this.getDetail()
    }


}
</script>

<style scoped>
.el-button--text {
    margin-top: -16px;
}

.wapper {
    padding: 15px;
}

.header {
    margin-bottom: 15px;
}

.content-wapper {
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 30px;
    padding-top: 15px;
    background: #fff;
}

.title {
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin: 30px 0 10px 0;
}

.info-wapper li {
    margin: 15px 0;
}

.info-wapper li div {
    display: inline-block;
    width: 400px;
    position: relative;
    word-break: break-word;
}

.info-wapper .special {
    width: 800px;
}

.info-wapper span {
    margin-left: 130px;
    display: inline-block;
    vertical-align: top;
}

.info-wapper label {
    color: #909399;
    display: inline-block;
    width: 100px;
    text-align: right;
    position: absolute;
    top: 0;
}

.textarea {
    display: inline-block;
    width: 500px;
}

.images-wapper {
    border-top: 1px dashed #909399;
    margin-top: 30px;
}

.info-wapper .el-image {
    width: 210px;
    height: 100px;
    border-radius: 6px;
    margin-left: 15px;
}

.table-wapper {
    margin-left: 130px;
    width: 550px;
}

.table-wapper label {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    display: block;
    font-weight: bold;
    border: 1px solid #d6dbe5;
    border-bottom: none;
}

.table-wapper table {
    border: 1px solid #d6dbe5;
    width: 100%;
}

.table-wapper td {
    padding: 10px;
    border-bottom: 1px solid #d6dbe5;
    border-right: 1px solid #d6dbe5;
}

.table-wapper tr:first-child td {
    font-weight: bold;
    background: #f9f9f9;
}

.table-top {
    width: 100%;
    font-weight: bold;
    border: 1px solid #cdd0d6;
    border-bottom: none;
    height: 50px;
    background: #fff;
    padding-top: 15px;
    padding-left: 10px;
}
</style>